/**
 *
 * @author Matthew Rawson @ 14/02/2018 17:14
 * @description
 * @notes
 *
 */
import React, {Component, Children} from "react"
import PropTypes from "prop-types"
import {get} from "lodash"

import id from "@irati/utils/id"
import Loading from "@irati/ui/src/Loading"
import Http404 from "@irati/ui/src/Errors/Http404"
import {fetchSchedule} from "@irati/insights/services/schedule"
import authentication from "@irati/auth"

import {ListFilter} from "../ListFilter"

class ScheduleFilter extends Component {
  static propTypes = {
    schedule: PropTypes.object.isRequired,
    children: PropTypes.node
  }
  static defaultProps = {
    children: null
  }

  constructor(props) {
    super(props)
    this.state = {
      load: this.getSchedule(props.schedule),
      schedule: null,
      filters: null
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.getSchedule(nextProps.schedule)
  }

  getSchedule = (scheduleObj) => {
    const tenant = authentication.userTenant().uuid
    const load = fetchSchedule({tenant, id: scheduleObj.id}).then((schedule) => {
      this.setState({schedule})
    })

    return load
  }

  handleFilterChange = (filters) => {
    this.setState({filters})
  }

  render() {
    const idNamespace = id("ScheduleFilter", this.props)
    const {schedule, filters} = this.state
    const {children} = this.props

    /** ComponentProps is used to forward props through <NestedRoute>'s */
    const clonedChildren = Children.map(children, (child, index) => {
      return React.cloneElement(child, {
        componentProps: {
          id: id(get(child, "props.path") || index, idNamespace),
          schedule,
          filters
        }
      })
    })

    return (
      <div id={idNamespace}>
        <ListFilter id={idNamespace} onChange={this.handleFilterChange} hasTime hasDriver />
        <Loading load={this.state.load} Error={Http404}>
          {clonedChildren}
        </Loading>
      </div>
    )
  }
}

export default ScheduleFilter
